// removed by extract-text-webpack-plugin
module.exports = {"global-footer":"GlobalFooter__global-footer","globalFooter":"GlobalFooter__global-footer","container":"GlobalFooter__container","orange-bar":"GlobalFooter__orange-bar","orangeBar":"GlobalFooter__orange-bar"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalFooter/GlobalFooter.css
// module id = 1379
// module chunks = 8